module.exports = __webpack_public_path__ + "static/media/hour.2cc55192.svg";